import {createContext} from "react";
import {useContextStrict} from "@web-libs/core/context/context.functions";
import {UserType} from "@web-libs/features/users/domain/user.types";
import {OwnUserDTO} from "@web-libs/features/users/api/user-dto.types";


type OwnUserConcern = {
    getId: () => Promise<string>;
    getName: () => Promise<string>;
    isClient: () => Promise<boolean>;
    isEmployee: () => Promise<boolean>;
}
export const OwnUserContext = createContext<OwnUserConcern|null>(null);

export const useOwnUser = () => {
    return useContextStrict(OwnUserContext);
}



export const createOwnUserConcern = (getOwnUser: () => Promise<OwnUserDTO>): OwnUserConcern => {
    let _ownUser: OwnUserDTO;

    const _getOwnUser = async (): Promise<OwnUserDTO> => {
        if(!_ownUser) _ownUser = await getOwnUser();
        return _ownUser;
    }

    const _getId = async (): Promise<string> => {
        return (await _getOwnUser()).id;
    }

    const _getOwnTypes = async (): Promise<UserType[]> => {
        return (await _getOwnUser()).userTypes.map((userTypeDTO) => userTypeDTO.userType.name);
    }

    const isClient = async (): Promise<boolean> => {
        const _ownTypes = await _getOwnTypes();
        return _ownTypes.every((userType) => userType === "USER");
    }

    const isEmployee = async (): Promise<boolean> => {
        const _ownTypes = await _getOwnTypes();
        return _ownTypes.some((userType) => userType === "EMPLOYEE");
    }

    const getName = async (): Promise<string> => {
        const ownUserDTO = await _getOwnUser();
        return ownUserDTO.firstName + " " + ownUserDTO.lastName;
    }

    return {
        getId:_getId,
        isClient,
        isEmployee,
        getName
    }
}
